import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Slider from "react-slick";
import React from 'react';

export default function AboutTeam() {
    const [selectedMember, setSelectedMember] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
          const location = useLocation();

    const openModal = (member) => {
        setSelectedMember(member);
        setIsOpen(true);
    };
    const closeModal = () => {
        setSelectedMember(null);
        setIsOpen(false);
    };

    const socialIcons = {
        facebook: "fab fa-facebook-f",
        instagram: "fab fa-instagram",
        twitter: "fab fa-twitter",
        linkedin: "fab fa-linkedin-in",
    };


    const boardDirectors = [
        {
            name: "Suresh Goyal",
            designation: "Founder & Managing Director",
            img: "/assets/images/rajesh-team1.webp",
            alt: "Suresh Goyal",
            description: `
            With over four decades of expertise in laundry operations, Suresh built Supershine on a foundation of hands-on experience spanning premium hospitality brands like Oberoi, Hyatt Regency, and InterContinental. A B.E. graduate from The Technological Institute of Textiles and Sciences, Bhiwani, he further honed his craft managing laundry operations across Gulf countries including Bahrain and Nepal. His vision in 1990 transformed industrial laundry into a science, delivering reliable, scalable solutions that power industries globally today.
            `,
            // social: {
            //     linkedin: "#",
            // },
        },
        // {
        //     name: "Kriti Shukla Goyal",
        //     designation: "Director",
        //     img: "/assets/images/anita-khanna-team2.webp",
        //     alt: "Kriti Shukla Goyal",
        //     description: `
        //    A Cornell-trained engineer with a Master's in Electrical and Computer Engineering and a background in IT and quality assurance at Tata Consultancy Services, Kriti brings strong technical rigour and systems thinking to every challenge she takes on. Her experience spans software quality assurance, performance analysis, and applied research across institutions including Cornell University and IIT Kanpur.
        //     `,
          
        // },
        {
            name: "Karan Goyal",
            designation: "Director",
            img: "/assets/images/vikram-singh.webp",
            alt: "Karan Goyal",
            description: `
            An MBA from Fisher College of Business, Ohio State University, Karan is a serial entrepreneur with over two decades in the laundry industry. He has successfully executed large-scale turnkey laundry projects across hotels, hospitals, and railways, co-founded India's largest commercial laundry in Delhi-NCR, and leads India's largest laundry equipment and services company.
            `,
            social: {
                linkedin: "https://www.linkedin.com/in/karan-goyal-51bb0315/",
            },
        },
    ];




  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const section = document.getElementById(id);

      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 100); // small delay for DOM render
      }
    }
  }, [location]);



    return (

        <>
            <section className="director-sec" id="our-team" >
                <div className="container">
                    <div className="director-wrapper">
                        <div className="col-md-12">
                            <div className="board-heading">
                                <h3 className="heading center-heading">Meet The Team</h3>
                            </div>
                        </div>
                        <div className="director-board row">
                            {boardDirectors.map((director, index) => (
                                <div key={index} className="col-12 col-sm-12 col-md-6 col-lg-4">
                                    <div className="director-card">
                                        <div className="author-name">
                                            <div className="image">
                                                <img src={director.img} alt={director.alt} className="img-responsive" />
                                            </div>
                                            <div className="text">
                                                <div className="name gradient-color">{director.name}</div>
                                                <p className="des">{director.designation}</p>
                                            </div>
                                        </div>
                                        <div className="read-more-btn">
                                            <Link className="arrow-butn" onClick={() => openModal(director)} >
                                                Read More <img src="/assets/images/arrow.webp" loading="lazy" alt="arrow" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
                {/* Popup Modal */}
                {selectedMember && (
                    <div className={`teamPopup-model  ${isOpen ? "is-open" : ""}`}>
                        <div className="overlay" onClick={closeModal}></div>
                        <div className="model-body">
                            <button className="close-btn" onClick={closeModal}>
                                <img src="/assets/images/popup-cross-icon.webp" alt="close" />
                            </button>
                            <div className="team-model-wrapper">
                                <div className="modal-content-area">
                                    <div className="model-lefr-img">
                                        <img src={selectedMember.img} alt={selectedMember.alt} className="modal-img" />
                                    </div>
                                    <div className="model-right-contet">
                                        <div className="title">{selectedMember.name}</div>
                                        <div className="description-text">{selectedMember.designation}</div>
                                        {selectedMember.description
                                            .split("\n")
                                            .filter(para => para.trim() !== "")
                                            .map((para, index) => (
                                                <p key={index}>{para}</p>
                                            ))}
                                        {selectedMember.social && (
                                            <div className="social-icons">
                                                <ul>
                                                    {Object.entries(selectedMember.social).map(([key, url]) => (
                                                        <li key={key}>
                                                            <Link to={url} target="_blank">
                                                                <i className={socialIcons[key]}></i>
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        </>
    );
}




